import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';

interface Props {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

function PageModal({ open, onClose, children }: Props) {
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden'; // 바디 스크롤 잠금
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener('keydown', onKey);
    };
  }, [open, onClose]);

  if (!open) return null;

  return createPortal(
    <Sheet role="dialog" aria-modal="true">
      <Panel>{children}</Panel>
    </Sheet>,
    document.body,
  );
}

const Sheet = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: center;
  z-index: 2000;
`;

const Panel = styled.div`
  width: 100%;
  max-width: 900px;
  height: 100%;
  background: #f3f4f6;
  overflow: auto;
  box-shadow: 0 0 20px hsla(0, 0%, 51%, 0.15);
  /* 필요하면 상단 close 버튼 공간 패딩 등 */
`;

export default PageModal;
